import NotificationViewModalPresenter from "./NotificationViewModalPresenter";
import React, { useEffect, useState } from "react";
interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  notificationViewData?: any;
  trans?: any;
}
const NotificationViewModalController = ({
  isModalOpen,
  closeModal,
  notificationViewData,
  trans,
}: ModalInterface) => {
  return (
    <div>
      <NotificationViewModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        notificationViewData={notificationViewData}
        trans={trans}
      />
    </div>
  );
};

export default NotificationViewModalController;
